import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_AUTH_SESSION_SCHEMA_LITERAL = {
    title: 'Schéma Auth Session',
    description: 'Décrit Auth Session',
    version: 2,
    keyCompression: false,
    primaryKey: 'SESSION_ID',
    type: 'object',
    properties: {
        SESSION_ID: { type: 'string', maxLength : 36 },
        USER_ID: { type: 'string', maxLength : 36 },
        USER_PERMS: { type: 'string' },
        CODE_PIN: { type: ['string', 'null'] },
        IS_LOCKED: { type: ['number', 'null'] },
    },
    required: [ 'SESSION_ID' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_AUTH_SESSION_SCHEMA_LITERAL);
export type RxCluAuthSessionDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_AUTH_SESSION_SCHEMA: RxJsonSchema<RxCluAuthSessionDocumentType> = CLU_AUTH_SESSION_SCHEMA_LITERAL;
